import { z } from "zod";
import { RevisionIdSchema } from "../primitives/ids.js";
/** QA-001: revision id must be present on completed quality-gate envelopes. */
export const QA001_REVISION_BINDING_CHECK_IDS = {
    GRAPH_TRUTH_CONTEXT_REQUIRED: "qa-001.graph_truth_context.required",
    REVISION_ON_ENVELOPE: "qa-001.business_graph_revision.bound",
    MANIFEST_REVISION_ALIGNMENT: "qa-001.manifest_revision_alignment",
};
export const QualityGateRevisionBindingV1Schema = z
    .object({
    businessGraphRevisionId: RevisionIdSchema,
    boundAt: z.string().datetime().optional(),
})
    .strict();
//# sourceMappingURL=quality-gate-revision-binding.js.map